import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  GetOrganisationBoardsRequestType,
  GetOrganisationBoardsResponseType,
} from '../types';

export const getOrganisationBoards = async ({
  pathParams: { organisationId },
}: GetOrganisationBoardsRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards`;

  const { data } =
    await apiAuthClient.get<GetOrganisationBoardsResponseType>(url);

  return data;
};
